import { APPROVAL_FLOW_ITEM_TYPES } from '@/administration/management/approvalFlow/approvalFlowItemTypes.constants';
import type {
  ApprovalFlowItemTypeConfig,
  WorkbookTypeFlags,
} from '@/administration/management/approvalFlow/approvalFlowItemTypes.constants';

/** The item types Approval Flows currently apply to on this server. */
export function getEnabledApprovalFlowItemTypes(): ApprovalFlowItemTypeConfig[] {
  return APPROVAL_FLOW_ITEM_TYPES.filter((config) => config.isEnabled());
}

// The checks below find the matching type first and only then ask whether it is enabled, so an unknown or missing type
// answers false without reading server configuration, which throws before it loads.

/** Whether Approval Flows apply to this item type, e.g. a Version History's `versionedItemType`. */
export function isApprovalFlowSupportedItemType(itemType: string | undefined): boolean {
  const config = APPROVAL_FLOW_ITEM_TYPES.find((candidate) => candidate.itemType === itemType);
  return config !== undefined && config.isEnabled();
}

/** The registered type of the open workbook, whether or not it is currently enabled. */
export function getApprovalFlowItemTypeForWorkbook(flags: WorkbookTypeFlags): ApprovalFlowItemTypeConfig | undefined {
  return APPROVAL_FLOW_ITEM_TYPES.find((config) => config.matchesWorkbook(flags));
}

/** Whether Approval Flows apply to the open workbook. */
export function isApprovalFlowSupportedWorkbook(flags: WorkbookTypeFlags): boolean {
  const config = getApprovalFlowItemTypeForWorkbook(flags);
  return config !== undefined && config.isEnabled();
}
